import React from 'react'
import NumberFormat from 'react-number-format'

const PriceFormat = (props) => {
  return (
    <NumberFormat
      value={props.value}
      displayType={'text'}
      thousandSeparator={true}
      prefix={'£'}
    />
  )
}

export default PriceFormat
